import { IVariantExtended } from '@src/interfaces';
import Classify from '@utils/Classify';
import React, { CSSProperties, HTMLAttributes } from 'react';

type Props = {
  backgroundColor?: string,
  backgroundName?: string,
  color?: string,
  fixedWidth?: boolean
  flip?: 'horizontal' | 'vertical' | 'both' | undefined,
  left?: number,
  name: string,
  regular?: boolean,
  right?: number,
  size?: string,
  spin?: boolean,
  variant?: IVariantExtended,
  backgroundVariant?: IVariantExtended,
  upgrade?: boolean,
};

const Icon: React.FC<Props & HTMLAttributes<HTMLSpanElement>> = ({ ...props }) => {

  const v5_name: any = {
    'close': 'times fas',
    'refresh': 'sync fas',
    'files-o': 'copy',
    'files': 'copy fas',
    'money': 'money-bill fas',
    'ticket': 'ticket-alt fas',
    'bar-chart': 'chart-bar',
    'bar-chart-o': 'chart-bar',
    'dollar': 'dollar-sign fas',
    'pie-chart': 'chart-pie fas',
    'cloud-download': 'cloud-download-alt fas',
    'television': 'tv fas',
    'file-text-o': 'file-alt',
    'shield': 'shield-alt fas',
    'calendar': 'calendar-alt',
    'clock-o': 'clock fas'
  };

  const getName = (name: string) => {
    if (props.upgrade) {
      if (v5_name[name]) {
        return v5_name[name];
      }
      if (name.substring(name.length - 2) == '-o') {
        return name.substring(0, name.length - 2);
      }
      return name + ' fas';
    }
    return name;
  }

  const buildStyle = (style: CSSProperties | undefined): CSSProperties => {
    const { left, right } = props;
    if (left) {
      style = Object.assign({}, style, { marginLeft: left });
    }
    if (right) {
      style = Object.assign({}, style, { marginRight: right });
    }
    return style ?? {};
  }

  const renderWithBackground = (style: CSSProperties): React.ReactElement<any, any> | null => {
    const { name, backgroundName, color, backgroundColor, variant, backgroundVariant, className, left, right, size, fixedWidth, spin, regular, upgrade, ...other } = props;
    const className2 = className + ' fa-stack';
    style = buildBackgroundStyle(style);
    const _suppress = { left, right, size, fixedWidth, spin, regular, upgrade };
    if (props.size == 'never') {
      console.log(_suppress);
    }
    return (
      <span {...other} style={style} className={className2}>
        {renderBackgroundIcon(backgroundName, backgroundColor, backgroundVariant)}
        {renderForgroundIcon(name, color, variant)}
      </span>
    );
  }

  const renderBackgroundIcon = (backgroundName: string | undefined, backgroundColor: string | undefined, backgroundVariant: IVariantExtended | undefined): React.ReactElement<any, any> | null => {
    return (
      <i className={'fa fa-' + getName(backgroundName ?? '') + ' fa-stack-2x' +
        Classify.addClassName(!!backgroundVariant, 'text-' + backgroundVariant)
      } style={{ color: backgroundColor ?? '' }}></i>
    );
  }

  const renderForgroundIcon = (name: string | undefined, color: string | undefined, variant: IVariantExtended | undefined): React.ReactElement<any, any> | null => {
    return (
      <i className={'fa fa-' + getName(name ?? '') + ' fa-stack-1x fa-inverse' +
        Classify.addClassName(!!variant, 'text-' + variant)
      } style={{ color: color ?? '' }}></i>
    );
  }

  const renderWithoutBackground = (style: CSSProperties): React.ReactElement<any, any> | null => {
    const { name, backgroundName, color, backgroundColor, variant, backgroundVariant, className, left, right, size, fixedWidth, spin, flip, regular, upgrade, ...other } = props;
    style.color = color ?? style.color ?? '';
    let reg = regular;
    if (!reg && (name + ' ').indexOf(' far ') >= 0) {
      reg = true;
    }
    return (
      <i
        {...other}
        // {...buildFlipData(flip)}
        className={
          'fa-' + getName(name) +
          Classify.addClassName(flip == 'horizontal' || flip == 'both', 'fa-flip-horizontal') +
          Classify.addClassName(flip == 'vertical' || flip == 'both', 'fa-flip-vertical') +
          Classify.addClassName(!!variant, 'text-' + variant) +
          Classify.addClassName(fixedWidth !== false, 'fa-fw') +
          Classify.addClassName(!!className, className) +
          Classify.addClassName(!!size, 'fa-' + size) +
          Classify.addClassName(!!spin, 'fa-spin') +
          Classify.addClassName(!reg, 'fas') +
          Classify.addClassName(!!reg, 'far')
        }
        style={style}
      />
    );
  }

  // const buildFlipData = (flip: 'horizontal' | 'vertical' | 'both' | undefined): object => {
  //   return flip === 'horizontal' ? { 'data-fa-transform': 'flip-h' } : buildFlipDataVertical(flip);
  // }

  // const buildFlipDataVertical = (flip: 'vertical' | 'both' | undefined): object => {
  //   return flip === 'vertical' ? { 'data-fa-transform': 'flip-v' } : buildFlipDataBoth(flip);
  // }

  // const buildFlipDataBoth = (flip: 'both' | undefined): object => {
  //   return flip === 'both' ? { 'data-fa-transform': 'flip-h flip-v' } : {};
  // }

  const buildBackgroundStyle = (style: CSSProperties | undefined): CSSProperties => {
    style = ensureStyle(style);
    style = addBackgroundFontSize(style);
    style = addBackgroundMargins(style);
    return style;
  }

  const ensureStyle = (style: CSSProperties | undefined): CSSProperties => {
    return style ?? {};
  }

  const addBackgroundFontSize = (style: CSSProperties): CSSProperties => {
    style.fontSize = style.fontSize || '1em';
    return style;
  }

  const addBackgroundMargins = (style: CSSProperties): CSSProperties => {
    style.marginTop = style.marginTop || '-0.25em';
    style.marginLeft = style.marginLeft || '-0.05em';
    return style;
  }

  if (props.backgroundName) {
    return renderWithBackground(buildStyle(props.style));
  }

  return renderWithoutBackground(buildStyle(props.style));

}

export default React.memo(Icon);